import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { Toggle } from '../ui/Toggle';
import { DateTimePicker } from '../ui/DateTimePicker';
import { Select } from '../ui/Select';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { useWizardOptional } from '../../hooks/useWizard';
export function WizardStep2Schedule() {
  // Use optional wizard context - if it exists, use it; otherwise use local state
  const wizardContext = useWizardOptional();
  // Local state fallback
  const [localData, setLocalData] = useState({
    isPublished: false,
    orderingEnabled: false,
    scheduleEnabled: true,
    openDate: '',
    openTime: '09:00',
    closeDate: '',
    closeTime: '23:59',
    timezone: 'America/Chicago',
    closingSoonThreshold: '48',
    forceOpen: false,
    forceClosed: false,
    pauseOrdering: false,
    comingSoonMessage: 'Get ready! Store opens soon.',
    openWindowMessage: 'Order now before the store closes!',
    closedMessage: 'This store is now closed.',
    estimatedTimeline: 'Orders will be produced and shipped approximately 2 weeks after the store closes.'
  });
  const step2Data = wizardContext ? wizardContext.data.step2 : localData;
  const updateData = (updates: any) => {
    if (wizardContext) {
      wizardContext.updateStep2(updates);
    } else {
      setLocalData(prev => ({
        ...prev,
        ...updates
      }));
    }
  };
  return <div className="space-y-6" data-id="element-465">
      <Card title="Publishing & Ordering" description="Control when the store is visible and accepting orders." data-id="element-466">
        <div className="space-y-6" data-id="element-467">
          <div className="flex flex-col space-y-4 p-4 bg-gray-50 rounded-md border border-gray-200" data-id="element-468">
            <Toggle label="Publish Storefront" description="Store is visible to customers (unless scheduled for later)" checked={step2Data.isPublished} onChange={checked => updateData({
            isPublished: checked
          })} data-id="element-469" />
            <div className="h-px bg-gray-200" data-id="element-470" />
            <Toggle label="Ordering Enabled" description="Customers can add items to cart and checkout" checked={step2Data.orderingEnabled} onChange={checked => updateData({
            orderingEnabled: checked
          })} data-id="element-471" />
            <div className="h-px bg-gray-200" data-id="element-472" />
            <Toggle label="Enable Schedule" description="Automatically open and close based on dates" checked={step2Data.scheduleEnabled} onChange={checked => updateData({
            scheduleEnabled: checked
          })} data-id="element-473" />
          </div>

          {step2Data.scheduleEnabled && <div className="grid grid-cols-1 gap-6" data-id="element-474">
              <DateTimePicker label="Open Date & Time *" dateValue={step2Data.openDate} timeValue={step2Data.openTime} timezoneValue={step2Data.timezone} onDateChange={val => updateData({
            openDate: val
          })} onTimeChange={val => updateData({
            openTime: val
          })} onTimezoneChange={val => updateData({
            timezone: val
          })} data-id="element-475" />

              <DateTimePicker label="Close Date & Time *" dateValue={step2Data.closeDate} timeValue={step2Data.closeTime} timezoneValue={step2Data.timezone} onDateChange={val => updateData({
            closeDate: val
          })} onTimeChange={val => updateData({
            closeTime: val
          })} onTimezoneChange={val => updateData({
            timezone: val
          })} data-id="element-476" />

              <Select label="Closing Soon Threshold" value={step2Data.closingSoonThreshold} onChange={e => updateData({
            closingSoonThreshold: e.target.value
          })} options={[{
            value: '24',
            label: '24 Hours Before Close'
          }, {
            value: '48',
            label: '48 Hours Before Close'
          }, {
            value: '72',
            label: '72 Hours Before Close'
          }]} data-id="element-477" />
            </div>}

          <div className="border-t border-gray-200 pt-6" data-id="element-478">
            <h4 className="text-sm font-medium text-gray-900 mb-4" data-id="element-479">
              Manual Overrides (Admin Only)
            </h4>
            <div className="flex space-x-3" data-id="element-480">
              <Button variant="outline" size="sm" onClick={() => updateData({
              forceOpen: !step2Data.forceOpen,
              forceClosed: false,
              pauseOrdering: false
            })} data-id="element-481">
                {step2Data.forceOpen ? '✓ ' : ''}Force Open Now
              </Button>
              <Button variant="outline" size="sm" onClick={() => updateData({
              forceClosed: !step2Data.forceClosed,
              forceOpen: false,
              pauseOrdering: false
            })} data-id="element-482">
                {step2Data.forceClosed ? '✓ ' : ''}Force Close Now
              </Button>
              <Button variant="danger" size="sm" onClick={() => updateData({
              pauseOrdering: !step2Data.pauseOrdering,
              forceOpen: false,
              forceClosed: false
            })} data-id="element-483">
                {step2Data.pauseOrdering ? '✓ ' : ''}Pause Ordering
              </Button>
            </div>
          </div>
        </div>
      </Card>

      <Card title="Customer Messaging" description="Messages displayed to customers during different store states." data-id="element-484">
        <div className="space-y-4" data-id="element-485">
          <Input label="Coming Soon Message" placeholder="Get ready! Store opens soon." value={step2Data.comingSoonMessage} onChange={e => updateData({
          comingSoonMessage: e.target.value
        })} data-id="element-486" />
          <Input label="Open Window Message" placeholder="Order now before the store closes!" value={step2Data.openWindowMessage} onChange={e => updateData({
          openWindowMessage: e.target.value
        })} data-id="element-487" />
          <Input label="Closed Message" placeholder="This store is now closed." value={step2Data.closedMessage} onChange={e => updateData({
          closedMessage: e.target.value
        })} data-id="element-488" />

          <div data-id="element-489">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-490">
              Estimated Production & Delivery Timeline
            </label>
            <textarea className="w-full rounded-md border border-gray-300 p-2 text-sm focus:ring-red-500 focus:border-red-500" rows={3} placeholder="Orders will be produced and shipped approximately 2 weeks after the store closes." value={step2Data.estimatedTimeline} onChange={e => updateData({
            estimatedTimeline: e.target.value
          })} data-id="element-491" />
          </div>
        </div>
      </Card>
    </div>;
}